(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initAnnouncementSlider = () => {
    document.querySelectorAll('.announcement-bar__slide').forEach((slider) => {
      if (slider.dataset.initialized === 'true') return;

      const section = slider.closest('.announcement-bar');
      const announcementId = slider.dataset.announcementId;
      const slideCount = Number(slider.dataset.slideCount || 0);
      const swiperElement = slider.querySelector(`.announcement-js-${announcementId}`);

      if (!section || !swiperElement || !window.Swiper || slideCount < 1) return;

      slider.dataset.initialized = 'true';

      const wantsAutoplay = section.dataset.autoplay === 'true';
      const interval = Math.max(Number(section.dataset.interval || 7000), 5000);
      const shouldAutoplay = wantsAutoplay && slideCount > 1 && !prefersReducedMotion.matches;

      const options = {
        loop: slideCount > 1,
        allowTouchMove: slideCount > 1,
        speed: 450,
        navigation: {
          nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
          prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
        },
      };

      if (shouldAutoplay) {
        options.autoplay = {
          delay: interval,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      const swiper = new Swiper(swiperElement, options);

      if (shouldAutoplay && swiper.autoplay) {
        section.addEventListener('focusin', () => swiper.autoplay.stop());
        section.addEventListener('focusout', () => swiper.autoplay.start());
      }
    });
  };

  initAnnouncementSlider();

  document.addEventListener('shopify:section:load', initAnnouncementSlider);
})();
